import { createSelector } from 'reselect'

const getUserData = state => state.user.data

const userCannySelector = createSelector(
	[getUserData],
	userData => userData.cannyProperties
)

export default userCannySelector
